import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "intent"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { optimizeLegibility } from '@flowio/react-theme';
import React from 'react';

var getColor = function getColor(intent) {
  switch (intent) {
    case 'negative':
      return '#d2431f';

    case 'positive':
      return '#128a00';

    case 'warning':
      return '#b4810b';

    default:
      return undefined;
  }
};

var Feedback = function Feedback(_ref) {
  var children = _ref.children,
      intent = _ref.intent,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var rootStyles = /*#__PURE__*/css(_objectSpread(_objectSpread({}, optimizeLegibility()), {}, {
    display: 'block',
    paddingTop: '8px',
    fontSize: '0.75rem',
    fontWeight: 500,
    color: getColor(intent)
  }), process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ZlZWRiYWNrLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQ3FCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ZlZWRiYWNrLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IG9wdGltaXplTGVnaWJpbGl0eSB9IGZyb20gJ0BmbG93aW8vcmVhY3QtdGhlbWUnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB0eXBlIHsgRm9ybUdyb3VwSW50ZW50IH0gZnJvbSAnLi4vdHlwZXMnO1xuXG50eXBlIE93blByb3BzID0ge1xuICBpbnRlbnQ6IEZvcm1Hcm91cEludGVudDtcbn07XG5cbnR5cGUgVW5oYW5kbGVkUHJvcHMgPSBPbWl0PFxuICBSZWFjdC5IVE1MQXR0cmlidXRlczxIVE1MRGl2RWxlbWVudD4sXG4gIGtleW9mIE93blByb3BzXG4+O1xuXG50eXBlIFByb3BzID0gT3duUHJvcHMgJiBVbmhhbmRsZWRQcm9wcztcblxuY29uc3QgZ2V0Q29sb3IgPSAoXG4gIGludGVudDogRm9ybUdyb3VwSW50ZW50LFxuKTogc3RyaW5nIHwgdW5kZWZpbmVkID0+IHtcbiAgc3dpdGNoIChpbnRlbnQpIHtcbiAgICBjYXNlICduZWdhdGl2ZSc6XG4gICAgICByZXR1cm4gJyNkMjQzMWYnO1xuICAgIGNhc2UgJ3Bvc2l0aXZlJzpcbiAgICAgIHJldHVybiAnIzEyOGEwMCc7XG4gICAgY2FzZSAnd2FybmluZyc6XG4gICAgICByZXR1cm4gJyNiNDgxMGInO1xuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICB9XG59O1xuXG5jb25zdCBGZWVkYmFjazogUmVhY3QuRkM8UHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIGludGVudCxcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IHtcbiAgY29uc3Qgcm9vdFN0eWxlcyA9IGNzcyh7XG4gICAgLi4ub3B0aW1pemVMZWdpYmlsaXR5KCksXG4gICAgZGlzcGxheTogJ2Jsb2NrJyxcbiAgICBwYWRkaW5nVG9wOiAnOHB4JyxcbiAgICBmb250U2l6ZTogJzAuNzVyZW0nLFxuICAgIGZvbnRXZWlnaHQ6IDUwMCxcbiAgICBjb2xvcjogZ2V0Q29sb3IoaW50ZW50KSxcbiAgfSk7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2IHsuLi51bmhhbmRsZWRQcm9wc30gY3NzPXtyb290U3R5bGVzfT5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEZlZWRiYWNrO1xuIl19 */");
  return jsx("div", _extends({}, unhandledProps, {
    css: rootStyles
  }), children);
};

export default Feedback;